/* eslint-disable no-eval */
import Vue from 'vue'
import { formatValue } from '@/services/convert'

export const calculateHeight = (
  tableId,
  pagination,
  dynamicTable,
  isTenant,
  isTile,
  isSetting,
) => {
  const bodyHeight = Math.round(
    document.querySelector('body').getBoundingClientRect().height,
  )
  const element = document.querySelector('#' + tableId)
  if (element) {
    const tablePosition = Math.round(element.getBoundingClientRect().top)
    return dynamicTable
      ? '730px'
      : isTile
        ? bodyHeight - tablePosition - (pagination ? 98 : 60) + 'px'
        : bodyHeight -
        tablePosition -
        (pagination ? 50 : isTenant ? 75 : isSetting ? 58 : 60) +
        'px'
  }
}

export const calculateGridHeight = (
  tableId,
  pagination,
  dynamicTable,
  isClose,
  isAnalysis,
  isTakeoff,
  isTile,
) => {
  const bodyHeight = Math.round(
    document.querySelector('body').getBoundingClientRect().height,
  )
  const element = document.querySelector('#' + tableId)
  if (element) {
    const tablePosition = Math.round(element.getBoundingClientRect().top)
    if (dynamicTable) {
      return (
        bodyHeight -
        tablePosition -
        (pagination ? 50 : isAnalysis ? 50 : 6) +
        'px'
      )
    } else if (isClose) {
      return (
        bodyHeight -
        tablePosition -
        (pagination ? (isClose ? 13 : 53) : 10) +
        'px'
      )
    } else if (isTakeoff) {
      return bodyHeight - tablePosition + 470 + 'px'
    } else if (isTile) {
      return bodyHeight - tablePosition - (pagination ? 69 : 10) + 'px'
    } else {
      return bodyHeight - tablePosition - (pagination ? 53 : 10) + 'px'
    }
  }
}

export const calculateHeightReport = (tableId, pagination) => {
  const bodyHeight = window.innerHeight
  const element = document.querySelector('#' + tableId)
  if (element) {
    const mainHeight = bodyHeight - (!pagination ? 386 : 24)
    return mainHeight + 'px'
  }
}

export const calculateBuildingGeneralHeight = (tableId, isTenant) => {
  const bodyHeight = Math.round(
    document.querySelector('body').getBoundingClientRect().height,
  )
  const element = document.querySelector('#' + tableId)
  if (element) {
    const tablePosition = Math.round(element.getBoundingClientRect().top)
    return bodyHeight - tablePosition - (isTenant ? 32 : 300) + 'px'
  }
}

export const calculateAreaBuildingFootprint = (
  totalBuilding,
  numberOfStories,
) => {
  if (totalBuilding && numberOfStories) {
    const value = Math.round(totalBuilding / numberOfStories)
    if (isNaN(value)) {
      return 0
    }
    if (!isFinite(value)) {
      return 0
    }
    return value
  } else {
    return null
  }
}

export const calculatePerimeterBuildingFootprint = totalBuilding => {
  if (totalBuilding) {
    const value = Math.round(Math.sqrt(totalBuilding) * 4)
    if (isNaN(value)) {
      return 0
    }
    if (!isFinite(value)) {
      return 0
    }
    return value
  } else {
    return null
  }
}

export const calculatePerimeter = (numberOfBuildings, area) => {
  if (numberOfBuildings === '0') {
    numberOfBuildings = 1
  }
  const value = Math.round(
    Math.sqrt(area / numberOfBuildings) * numberOfBuildings * 4,
  )
  if (isNaN(value)) {
    return 0
  }
  if (!isFinite(value)) {
    return 0
  }
  return value
}

export const calculateQantityPer = (quantity, area) => {
  if (area) {
    const value = parseFloat(((quantity / area) * 100).toFixed(2))
    if (isNaN(value)) {
      return 0
    }
    if (!isFinite(value)) {
      return 0
    }
    return value
  } else {
    return null
  }
}

export const calculateQantity = (quantityper, area) => {
  if (area) {
    const value = Math.round((quantityper / 100) * area)
    if (isNaN(value)) {
      return 0
    }
    if (!isFinite(value)) {
      return 0
    }
    return value
  } else {
    return null
  }
}

export const getDimensions = (params, height, data) => {
  const tableHeight =
    getRowHeight(params).rowHeight * data.length +
    getRowHeight(params).headerHeight +
    35
  if (data.length > 0) {
    if (tableHeight < Number(height.split('px')[0])) {
      return tableHeight + 'px'
    } else {
      return height
    }
  } else {
    return '200px'
  }
}

export const getRowHeight = params => {
  return params.api.getSizesForCurrentTheme()
}

export const showNotification = (type, message, description) => {
  Vue.prototype.$notification[type]({
    message: message,
    description: description,
  })
}

export const customComparator = (valueA, valueB) => {
  if (valueA && valueB) {
    if (isNaN(valueA) && isNaN(valueB)) {
      return valueA
        .toString()
        .toLowerCase()
        .localeCompare(valueB.toString().toLowerCase())
    }
  }
}

export const calculateBarHeight = elementId => {
  const element = document.querySelector('#' + elementId)
  if (element) {
    const tablePosition = Math.round(element.getBoundingClientRect().height)
    return tablePosition + 'px'
  } else {
    return '311px'
  }
}

export const evaluateQantity = value => {
  try {
    const quantity = eval(value)
    if (!isNaN(quantity) && quantity) {
      return formatValue(quantity, 0)
    } else {
      return 0
    }
  } catch (error) {
    return 'Error'
  }
}

export const convertCalculation = (
  formula,
  propData,
  calculationData,
  calculations,
) => {
  let calculation = formula
  let value = null
  calculations.forEach(element => {
    const position = formula
      .toLowerCase()
      .search(element.split(' - ')[0].toLowerCase())
    if (position > -1) {
      switch (element.split(' - ')[0]) {
        case 'ASH':
          if (calculationData && calculationData.average_Story_Height) {
            value = calculationData.average_Story_Height
          } else {
            value = 0
          }
          break
        case 'NB':
          if (calculationData && calculationData.numberOfBuilding) {
            value = calculationData.numberOfBuilding
          } else {
            value = 0
          }
          break
        case 'NS':
          if (calculationData && calculationData.number_Of_Stories) {
            value = calculationData.number_Of_Stories
          } else {
            value = 0
          }
          break
        case 'PERB':
          if (calculationData && calculationData.perimeter_Building_Footprint) {
            value = calculationData.perimeter_Building_Footprint
          } else {
            value = 0
          }
          break
        case 'PERG':
          if (
            propData &&
            propData.firstRowValues &&
            (propData.firstRowValues.interiorGroupId ||
              propData.firstRowValues.interior_Grouping_Id ||
              propData.firstRowValues.interiorGroupingId) &&
            propData.firstRowValues.perimeter
          ) {
            value = propData.firstRowValues.perimeter
          } else {
            value = 0
          }
          break
        case 'PERS':
          if (propData && propData.site && propData.site.perimeter) {
            value = propData.site.perimeter
          } else {
            value = 0
          }
          break
        case 'PERT':
          if (
            propData &&
            propData.tenant &&
            propData.tenant.id &&
            propData.tenant.perimeter
          ) {
            value = propData.tenant.perimeter
          } else {
            value = 0
          }
          break
        case 'SFB':
          if (calculationData && calculationData.area_Total_Building) {
            value = calculationData.area_Total_Building
          } else {
            value = 0
          }
          break
        case 'SFG':
          if (
            propData &&
            propData.firstRowValues &&
            (propData.firstRowValues.interiorGroupId ||
              propData.firstRowValues.interior_Grouping_Id ||
              propData.firstRowValues.interiorGroupingId) &&
            propData.firstRowValues.area
          ) {
            value = propData.firstRowValues.area
          } else {
            value = 0
          }
          break
        case 'SFR':
          if (calculationData && calculationData.area_Building_Footprint) {
            value = calculationData.area_Building_Footprint
          } else {
            value = 0
          }
          break
        case 'SFT':
          if (
            propData &&
            propData.tenant &&
            propData.tenant.id &&
            propData.tenant.area
          ) {
            value = propData.tenant.area
          } else {
            value = 0
          }
          break
        case 'SFS':
          if (propData && propData.site && propData.site.area) {
            value = propData.site.area
          } else if (calculationData && calculationData.totalSiteArea) {
            value = calculationData.totalSiteArea
          } else {
            value = 0
          }
          break
        default:
          value = 0
          break
      }
      calculation = calculation.replaceAll(element.split(' - ')[0], value)
    } else if (formula.toLowerCase().includes('peri')) {
      calculation = calculation.replaceAll('PERI', 0)
    }
  })
  const reg = /^[a-zA-Z]*$/gi
  if (reg.test(calculation)) {
    calculation = calculation.replaceAll(reg, 0)
  }
  return calculation
}

export const convertCalculationForTemplateAnalysisSheet = (
  formula,
  propData,
  calculations,
) => {
  let calculation = formula
  let value = null
  calculations.forEach(element => {
    const position = formula
      .toLowerCase()
      .search(element.split(' - ')[0].toLowerCase())
    if (position > -1) {
      switch (element.split(' - ')[0]) {
        case 'ASH':
          if (propData && propData.ash) {
            value = propData.ash
          } else {
            value = 0
          }
          break
        case 'NB':
          if (propData && propData.nb) {
            value = propData.nb
          } else {
            value = 0
          }
          break
        case 'NS':
          if (propData && propData.ns) {
            value = propData.ns
          } else {
            value = 0
          }
          break
        case 'PERB':
          if (propData && propData.perb) {
            value = propData.perb
          } else {
            value = 0
          }
          break
        case 'PERG':
          if (propData && propData.perg) {
            value = propData.perg
          } else {
            value = 0
          }
          break
        case 'PERS':
          if (propData && propData.pers) {
            value = propData.pers
          } else {
            value = 0
          }
          break
        case 'PERT':
          if (propData && propData.pert) {
            value = propData.pert
          } else {
            value = 0
          }
          break
        case 'SFB':
          if (propData && propData.sfb) {
            value = propData.sfb
          } else {
            value = 0
          }
          break
        case 'SFG':
          if (propData && propData.sfg) {
            value = propData.sfg
          } else {
            value = 0
          }
          break
        case 'SFR':
          if (propData && propData.sfr) {
            value = propData.sfr
          } else {
            value = 0
          }
          break
        case 'SFS':
          if (propData && propData.sfs) {
            value = propData.sfs
          } else {
            value = 0
          }
          break
        case 'SFT':
          if (propData && propData.sft) {
            value = propData.sft
          } else {
            value = 0
          }
          break
        default:
          break
      }
      calculation = calculation.replaceAll(element.split(' - ')[0], value)
    } else if (formula.toLowerCase().includes('peri')) {
      calculation = calculation.replaceAll('PERI', 0)
    }
  })
  const reg = /^[a-zA-Z]*$/gi
  if (reg.test(calculation)) {
    calculation = calculation.replaceAll(reg, 0)
  }
  return calculation
}

export const filterTakeoffs = (data, searchText) => {
  const list = data
  list.filter(data => {
    if (
      data['takeoffGrouping'].toLowerCase().includes(searchText.toLowerCase())
    ) {
      return data
    } else {
      const takeoffs = [...data['takeoffs']]
      data['takeoffs'] = []
      takeoffs.forEach(element => {
        if (
          element['takeoff'].toLowerCase().includes(searchText.toLowerCase())
        ) {
          data['takeoffs'].push(element)
        }
      })
      if (data['takeoffs'].length > 0) {
        return data
      }
    }
  })
  return list
}
